import { translate } from '@repo/phrase';

import { DaysFilter } from '@/components/filters/days-filter';
import { Filter } from '@/components/filters/filter';
import { useSearch } from '@/components/filters/search/search.hooks';

export const DaysFilterWrapper = () => {
    const { daysFilter, assetIdFilter } = useSearch();
    const daysFilterLabel = assetIdFilter ? 'filter_no_days' : `filter_days_${daysFilter}`;

    return (
        <Filter label={translate(daysFilterLabel)} data-testid="day-filter-wrapper" disabled={Boolean(assetIdFilter)}>
            <DaysFilter />
        </Filter>
    );
};
